import { Component, OnInit } from '@angular/core';
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";

@Component({
  selector: 'app-edit-product-range-modal',
  templateUrl: './edit-product-range-modal.component.html',
  styleUrls: ['./edit-product-range-modal.component.scss']
})
export class EditProductRangeModalComponent implements OnInit {


  public edit_product_range: any = {};

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,

  ) {}

  ngOnInit() {}

  public closeModal() {
    this.bsModalRef.hide();
    /*   this.modalService.setDismissReason('modalClosed');*/
    this.modalService.setDismissReason("modalClosed");
  }

  public closeModalAfterSave() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("modalSaved");
  }

  public editProductRange(event) {
    this.closeModalAfterSave()
  }

}



// WEBPACK FOOTER //
// /app/src/app/supplier-evaluation-form/edit-product-range-modal/edit-product-range-modal.component.ts